import React, { useEffect } from 'react';
import './cancare.css';
import HealthOverviewCard from './components/HealthOverviewCard';
import PillReminderCard from './components/PillReminderCard';
// import SubscriptionCard from './components/SubscriptionCard';
import TasksCard from './components/TasksCard';
import MapCard from './components/MapCard.jsx';
import EmergencyCard from './components/EmergencyCard.jsx';
import ActivityCard from './components/ActivityCard.jsx';
import HealthCard from './components/HealthCard.jsx';
import { Grid } from '@mui/material';
import DeviceCard from './components/DeviceCard.jsx';
import CompanionCard from './components/CompanionCard.jsx';
import useStore from '../../Store/Store.js';
import { find, isEmpty } from 'lodash';
import { SUBSCRIPTION_TYPE } from '../../constants/index.js';
import { useNavigate } from 'react-router-dom';
import RecipientsSelector from '../Components/RecipientsSelector.jsx';

export default function Main() {
  const history = useNavigate();
  const user = useStore((state) => state.user);
  const width = useStore((state) => state.screenWidth);
  const selectedRecipient = useStore((state) => state.selectedRecipient);

  const [emergencySubscription, setEmergencySubscription] = React.useState(null);

  React.useEffect(() => {
    if (!isEmpty(user)) {
      const data = find(user?.stripeInfo?.subscriptions, (i) => i.type === SUBSCRIPTION_TYPE.emergency);
      setEmergencySubscription(data);
    }
  }, [user]);

  React.useEffect(() => {
    if (isEmpty(user)) {
      history('/login');
    }
  }, [user]);

  return (
    <div
      // className="main-container"
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'flex-start',
        padding: '0 20px',
        maxWidth: '1200px',
        margin: '0 auto',
      }}
    >
      <div
        className="flex-column-a"
        style={{
          width: '100%',
          // maxWidth: '1000px',
        }}
      >
        <div className="frame-3e" style={{ display: width > 550 ? 'flex' : 'block' }}>
          <div className="frame-3f">
            <span className="peter-wilson">{user?.fullName || user?.userInfo?.firstName}</span>
          </div>
          <div className="frame-45">
            <RecipientsSelector />
          </div>
        </div>
        <div
          className="frame-4c"
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: '20px',
          }}
        >
          {/* <SubscriptionCard />
          {isEmpty(emergencySubscription) && isEmpty(selectedRecipient) && (
            <Grid container>
              <Grid sm={12} xs={12} md={8} lg={8}>
                <HealthOverviewCard />
              </Grid>
              <Grid sm={12} xs={12} md={4} lg={4}>
                <DeviceCard />
              </Grid>
            </Grid>
          )}

          {!isEmpty(emergencySubscription) && isEmpty(selectedRecipient) && (
            <Grid container>
              <Grid sm={12} xs={12} md={4} lg={4}>
                <CompanionCard />
              </Grid>
              <Grid sm={12} xs={12} md={4} lg={4}>
                <DeviceCard />
              </Grid>
              <Grid sm={12} xs={12} md={4} lg={4}>
                <EmergencyCard />
              </Grid>
            </Grid>
          )}

          {!isEmpty(selectedRecipient) && (
            <Grid container>
              <Grid sm={12} xs={12} md={4} lg={4}>
                <CompanionCard />
              </Grid>
              <Grid sm={12} xs={12} md={4} lg={4}>
                <DeviceCard />
              </Grid>
              <Grid sm={12} xs={12} md={4} lg={4}>
                <ActivityCard />
              </Grid>
            </Grid>
          )} */}
          <Grid container spacing={2} style={{ width: '100%' }}>
            <Grid item sm={12} xs={12} md={4} lg={4}>
              <CompanionCard />
            </Grid>
            <Grid item sm={12} xs={12} md={4} lg={4}>
              <DeviceCard />
            </Grid>
            <Grid item sm={12} xs={12} md={4} lg={4}>
              <ActivityCard />
            </Grid>
          </Grid>
          <Grid container style={{ width: '100%' }}>
            <HealthCard />
          </Grid>
          {/* <div className="frame-7a" style={{ width: '100%' }}> */}
          <Grid container spacing={2} style={{ width: '100%' }}>
            <Grid item sm={12} xs={12} md={4} lg={4}>
              <PillReminderCard />
            </Grid>
            <Grid item sm={12} xs={12} md={4} lg={4}>
              <TasksCard />
            </Grid>
            <Grid item sm={12} xs={12} md={4} lg={4}>
              <MapCard />
            </Grid>
          </Grid>
          {/* </div> */}
        </div>
      </div>
    </div>
  );
}
